import React from "react";
import Github from "./Github";

export default function ProjectEntry({ text, github, link}) {
  return (
    <div className="Content-paragraph-container">
      <div className="Content-paragraph-container">
        <p className="Content-paragraph">{text}</p>
        <hr />
        <a style={{height: "50px"}} href={github}><Github /></a>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/ProjectEntry.js